// src/components/admin/page-management/SeoTab.js
import React from 'react';

const SeoTab = ({ formData, handleInputChange, onSubmit }) => {
  return (
    <form onSubmit={onSubmit}>
      <div className="mb-4">
        <label className="block text-sm font-medium mb-1">Meta Title</label>
        <input
          type="text"
          name="metaTitle"
          className="w-full p-2 border rounded"
          value={formData.metaTitle}
          onChange={handleInputChange}
          placeholder={formData.title}
        />
        <p className="text-sm text-gray-500 mt-1">
          Leave blank to use the page title. Recommended length: 50-60 characters.
        </p>
      </div>
      
      <div className="mb-4">
        <label className="block text-sm font-medium mb-1">Meta Description</label>
        <textarea
          name="metaDescription"
          className="w-full p-2 border rounded"
          rows="3"
          value={formData.metaDescription}
          onChange={handleInputChange}
          placeholder={formData.description}
        ></textarea>
        <p className="text-sm text-gray-500 mt-1">
          Leave blank to use the page description. Recommended length: 150-160 characters.
        </p>
      </div>
      
      <button
        type="submit"
        className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded"
      >
        Save SEO Settings
      </button>
    </form>
  );
};

export default SeoTab;